import { createProfileRepository } from './profileRepository.js';
import { createProductosRepository } from './productosRepository.js';
import { createVentasComisionRepository } from './ventasComisionRepository.js';

export function createVendedorRepository({ getFirebase }) {
  const profile = createProfileRepository({ getFirebase });
  const productos = createProductosRepository({ getFirebase, profileRepo: profile });
  const comision = createVentasComisionRepository({ getFirebase });
  return { ...profile, ...productos, ...comision };
}
